module.exports = __webpack_public_path__ + "static/Laser dentistry smile before-5ebf605997a0c0f260ab76c35996b75a.jpg";